export function findHighestUntitledProjectIndex(arr: string[] = []) {
  let maxIndex = 0

  arr.forEach((name) => {
    const match = name.match(/^Untitled(?:\s*(\d+))?$/i)
    if (match) {
      const index = match[1] ? parseInt(match[1], 10) : 1
      if (index > maxIndex) {
        maxIndex = index
      }
    }
  })

  return maxIndex
}
